import Geometry from '@arcgis/core/geometry/Geometry';
import {BaseObject, IBaseObject} from './BaseObject';
import Point from '@arcgis/core/geometry/Point';
import {
  IPlanGestionMobilite,
  PlanGestionMobilite,
} from './PlanGestionMobilite';
import {ISagtFeature} from './SagtFeature';

export interface IdentifyEvenementSpontane {
  OBJECTID: string;
  ID: string;
  ID_ES: string;
  ID_TYPE_ES: string;
  DESCRIPTION_TYPE_ES: string;
  ID_PRECONISATION: string;
  DESCRIPTION_PRECONISATION: string;
  ID_MODE_PGM: string;
  DESCRIPTION_MODE_PGM: string;
  ID_ETAT_DETAILLE_PGM: string;
  DESCRIPTION_ETAT_DETAILLE_PGM: string;
  COULEUR_ETAT_DETAILLE_PGM: string;
  SHAPE: string;
}

export interface IEvenementSpontane extends IBaseObject {
  actif?: boolean;
  idSegment?: number;
  nomSegment?: string;
  idType?: number;
  descriptionType?: string;
  idPreconisation?: number;
  descriptionPreconisation?: string;

  features?: ISagtFeature[];
  pgm?: IPlanGestionMobilite;
  geometry?: Point;
}

export class EvenementSpontane
  extends BaseObject
  implements IEvenementSpontane {
  actif?: boolean;
  pgm?: PlanGestionMobilite;
  features?: ISagtFeature[];
  idSegment?: number;
  nomSegment?: string;
  idType?: number;
  descriptionType?: string;
  idPreconisation?: number;
  descriptionPreconisation?: string;

  constructor(props?: IEvenementSpontane) {
    super(props);

    if (props) {
      this.actif = props.actif;
      if (props.pgm) {
        this.pgm = new PlanGestionMobilite(props.pgm);
      }
      if (props.features) {
        this.features = props.features.map((x) => Object.assign({}, x));
      }
      this.idSegment = props.idSegment;
      this.nomSegment = props.nomSegment;
      this.idType = props.idType;
      this.descriptionType = props.descriptionType;
      this.idPreconisation = props.idPreconisation;
      this.descriptionPreconisation = props.descriptionPreconisation;
    }
  }

  format(): IEvenementSpontane {
    const item: IEvenementSpontane = {
      id: this.id,
      pgm: this.pgm?.format(),
      actif: this.actif,
      idPreconisation: this.idPreconisation,
      idType: this.idType,
      idSegment: this.idSegment,
      nomSegment: this.nomSegment,
      features: this.features?.map((x) => Object.assign({}, x)),
    };

    if (item.pgm) {
      if (item.pgm.idMode == null) {
        item.pgm.idMode = 2;
      }
    }

    if (item.id == null || item.id === -1) {
      // @ts-ignore
      delete item.id;
    }

    return item;
  }
}
